import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// ต้อง import global.js ก่อน routes เสมอ เพราะหน้าเพจต่าง ๆ อ่าน global.* ตอน module load
// ถ้าโหลดทีหลัง ค่าอย่าง global.field_groups / global.required_fields จะเป็น undefined
import "./components/global.js";
import "./i18n.js";
import Routes from "./routes";
import { ImagePreviewModal } from "./components/CustomComponent.js";
import "./assets/css/bootstrap.css";
import "./assets/css/style.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <div className="spinner-container" id="loading">
      <div className="loading-spinner"></div>
    </div>
    <ImagePreviewModal />
    <Routes />
  </BrowserRouter>
);
